import { useEffect, useState } from "react";

function OfferPopup() {
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    const enabled = localStorage.getItem("offer_enabled");
    const message = localStorage.getItem("offer_text");

    if (enabled === "true") {
      setText(message || "Enjoy 15% off your first ride with Jumeirah");
      setTimeout(() => setShow(true), 800); // smooth delay
    }
  }, []);

  if (!show) return null;

  return (
    <div className="offer-overlay">
      <div className="offer-box">

        <h2>{text}</h2>

        <button onClick={() => setShow(false)}>
          Close
        </button>

      </div>
    </div>
  );
}

export default OfferPopup;